import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class SupportDevicesService {
  constructor(private http: HttpClient) {}

  getDevices(pbxId: number, userId: string) {
    return this.http.get(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/users/${userId}/devices`);
  }

  createDevice(pbxId: number, userId: string) {
    return this.http.post(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/users/${userId}/devices`,
     {type: "SUPPORT"} );
  }

  deleteDevice(pbxId: number, userId: string, deviceId: string) {
    return this.http.delete(`${environment.apiEndpoint}/api/v1/pbxes/${pbxId}/users/${userId}/devices/${deviceId}`);
  }
}